module.exports = __webpack_public_path__ + "img/maintenance-2.92cc81a1.gif";